import React from 'react';
import Button from '../button/button';

const LightSelector = ({ handleImageChange, isNormalImage }) => {
    const icon = isNormalImage ? 'picto-light' : 'picto-brightness';
    const tooltipText = isNormalImage ? 'Passer au mode éclairement' : 'Passer au mode réaliste';

    const handleIconChangeClick = () => {
        handleImageChange(!isNormalImage); // Inversion de l'état de l'image
    };

    return (
        <div className='buttonContainerLight'>
            <div className='buttonContainerMainLight'>
                <Button
                    customClass={`buttonLight ${icon === 'picto-brightness' ? 'redBackground' : ''}`}
                    onClick={handleIconChangeClick}
                    icon={icon}
                />
                
                <span class="toolTipTextLight">{tooltipText}</span>
            </div>
        </div>
    );
};

export default LightSelector;